import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeePayroll  {
    _originalTypeClassName = "zERP.BO.EmployeePayroll";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeePayroll.translate = translateService;
}
this.Salaries = [];
this.Contributions = [];
this.Taxes = [];
this.Deductions = [];
this.LoanInstalments = [];
this.Variables = [];
this.AdhocAdvancePayments = [];
this.Id = null;
this.DaysWorked = null;
this.DaysInsured = null;
this.Overtimes = null;
this.AdvanceAmount = null;
this.BasicSalary = null;
this.OtherSalary = null;
this.MainSalary = null;
this.DailySalary = null;
this.HourlySalary = null;
this.TotalSalary = null;
this.EmployerContributions = null;
this.EmployeeContributions = null;
this.EmployerDeductions = null;
this.EmployeeDeductions = null;
this.Tax = null;
this.RegularTax = null;
this.PayableAmount = null;
this.EasterDays = null;
this.ChristmasDays = null;
this.LeaveDays = null;
this.DateIssued = null;
this.BonusAmount = null;
this.isFMYIssued = false;
this.isChecked = false;
this.PeriodWeight = null;
this.isRetrospective = false;
this.zeroTax = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DaysWorked:any;
DaysInsured:any;
Overtimes:any;
AdvanceAmount:any;
BasicSalary:any;
OtherSalary:any;
MainSalary:any;
DailySalary:any;
HourlySalary:any;
TotalSalary:any;
EmployerContributions:any;
EmployeeContributions:any;
EmployerDeductions:any;
EmployeeDeductions:any;
Tax:any;
RegularTax:any;
PayableAmount:any;
EasterDays:any;
ChristmasDays:any;
LeaveDays:any;
DateIssued:any;
BonusAmount:any;
isFMYIssued:any;
isChecked:any;
PeriodWeight:any;
isRetrospective:any;
zeroTax:any;
Contract:any;
Salaries:any;
Contributions:any;
Taxes:any;
Employee:any;
PDF:any;
Deductions:any;
PayrollFMYExportDetail:any;
PayrollCalculation:any;
Calendar:any;
PDFEncrypted:any;
LoanInstalments:any;
Variables:any;
AdhocAdvancePayments:any;
static setContract = ($this, value) => {
var oldValue = $this.Contract;
$this.Contract = value;
if (value != null) {
}
}
static setSalaries = ($this, items) => {
                if (items == null) items = [];
                if ($this.Salaries == null) $this.Salaries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Salaries.length > 0) {
                    Domain.EmployeePayroll.removeSalaries($this, $this.Salaries[0]);
                }

                Domain.EmployeePayroll.addManySalaries($this, copyItems);
            }
static addManySalaries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayroll.addSalaries($this, items[i]);
                }
            }
static addSalaries = ($this, item) => {
                if ($this.Salaries == null) $this.Salaries = [];
                if (item == null || $this.Salaries.indexOf(item) > -1) return;
                $this.Salaries.push(item);
}
static addRangeSalaries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayroll.addSalaries($this, item));
            }
static removeSalaries = ($this, item) => {
                if ($this == null || $this.Salaries == null || $this.Salaries.indexOf(item) === -1) return;
                var _index = $this.Salaries.indexOf(item);
                $this.Salaries.splice(_index, 1);
}
static clearSalaries = ($this) => { $this.Salaries = null; }
static setContributions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Contributions == null) $this.Contributions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Contributions.length > 0) {
                    Domain.EmployeePayroll.removeContributions($this, $this.Contributions[0]);
                }

                Domain.EmployeePayroll.addManyContributions($this, copyItems);
            }
static addManyContributions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayroll.addContributions($this, items[i]);
                }
            }
static addContributions = ($this, item) => {
                if ($this.Contributions == null) $this.Contributions = [];
                if (item == null || $this.Contributions.indexOf(item) > -1) return;
                $this.Contributions.push(item);
}
static addRangeContributions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayroll.addContributions($this, item));
            }
static removeContributions = ($this, item) => {
                if ($this == null || $this.Contributions == null || $this.Contributions.indexOf(item) === -1) return;
                var _index = $this.Contributions.indexOf(item);
                $this.Contributions.splice(_index, 1);
}
static clearContributions = ($this) => { $this.Contributions = null; }
static setTaxes = ($this, items) => {
                if (items == null) items = [];
                if ($this.Taxes == null) $this.Taxes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Taxes.length > 0) {
                    Domain.EmployeePayroll.removeTaxes($this, $this.Taxes[0]);
                }

                Domain.EmployeePayroll.addManyTaxes($this, copyItems);
            }
static addManyTaxes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayroll.addTaxes($this, items[i]);
                }
            }
static addTaxes = ($this, item) => {
                if ($this.Taxes == null) $this.Taxes = [];
                if (item == null || $this.Taxes.indexOf(item) > -1) return;
                $this.Taxes.push(item);
}
static addRangeTaxes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayroll.addTaxes($this, item));
            }
static removeTaxes = ($this, item) => {
                if ($this == null || $this.Taxes == null || $this.Taxes.indexOf(item) === -1) return;
                var _index = $this.Taxes.indexOf(item);
                $this.Taxes.splice(_index, 1);
}
static clearTaxes = ($this) => { $this.Taxes = null; }
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removePayments(oldValue, $this);
}
Domain.Employee.addPayments(value, $this);
}
}
static setPDF = ($this, value) => {
var oldValue = $this.PDF;
$this.PDF = value;
if (value != null) {
}
}
static setDeductions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Deductions == null) $this.Deductions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Deductions.length > 0) {
                    Domain.EmployeePayroll.removeDeductions($this, $this.Deductions[0]);
                }

                Domain.EmployeePayroll.addManyDeductions($this, copyItems);
            }
static addManyDeductions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayroll.addDeductions($this, items[i]);
                }
            }
static addDeductions = ($this, item) => {
                if ($this.Deductions == null) $this.Deductions = [];
                if (item == null || $this.Deductions.indexOf(item) > -1) return;
                $this.Deductions.push(item);
}
static addRangeDeductions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayroll.addDeductions($this, item));
            }
static removeDeductions = ($this, item) => {
                if ($this == null || $this.Deductions == null || $this.Deductions.indexOf(item) === -1) return;
                var _index = $this.Deductions.indexOf(item);
                $this.Deductions.splice(_index, 1);
}
static clearDeductions = ($this) => { $this.Deductions = null; }
static setPayrollFMYExportDetail = ($this, value) => {
var oldValue = $this.PayrollFMYExportDetail;
$this.PayrollFMYExportDetail = value;
if (value != null) {
if (oldValue != null) {
Domain.PayrollFMYExportDetail.removeEmployees(oldValue, $this);
}
Domain.PayrollFMYExportDetail.addEmployees(value, $this);
}
}
static setPayrollCalculation = ($this, value) => {
var oldValue = $this.PayrollCalculation;
$this.PayrollCalculation = value;
if (value != null) {
if (oldValue != null) {
Domain.PayrollCalculation.removeEmployees(oldValue, $this);
}
Domain.PayrollCalculation.addEmployees(value, $this);
}
}
static setCalendar = ($this, value) => {
var oldValue = $this.Calendar;
$this.Calendar = value;
if (value != null) {
if (oldValue != null && oldValue.Payroll != null) { oldValue.Payroll = null; }
if ($this.Calendar.Payroll !== $this) {
Domain.EmployeeWorkingCalendar.setPayroll(value, $this);
}
}
}
static setPDFEncrypted = ($this, value) => {
var oldValue = $this.PDFEncrypted;
$this.PDFEncrypted = value;
if (value != null) {
}
}
static setLoanInstalments = ($this, items) => {
                if (items == null) items = [];
                if ($this.LoanInstalments == null) $this.LoanInstalments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.LoanInstalments.length > 0) {
                    Domain.EmployeePayroll.removeLoanInstalments($this, $this.LoanInstalments[0]);
                }

                Domain.EmployeePayroll.addManyLoanInstalments($this, copyItems);
            }
static addManyLoanInstalments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayroll.addLoanInstalments($this, items[i]);
                }
            }
static addLoanInstalments = ($this, item) => {
                if ($this.LoanInstalments == null) $this.LoanInstalments = [];
                if (item == null || $this.LoanInstalments.indexOf(item) > -1) return;
                $this.LoanInstalments.push(item);
if (item.PayedOn != $this) {
Domain.EmployeeSalaryLoanInstalment.setPayedOn(item, $this);
}
}
static addRangeLoanInstalments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayroll.addLoanInstalments($this, item));
            }
static removeLoanInstalments = ($this, item) => {
                if ($this == null || $this.LoanInstalments == null || $this.LoanInstalments.indexOf(item) === -1) return;
                var _index = $this.LoanInstalments.indexOf(item);
                $this.LoanInstalments.splice(_index, 1);
item.PayedOn = null;
}
static clearLoanInstalments = ($this) => { $this.LoanInstalments = null; }
static setVariables = ($this, items) => {
                if (items == null) items = [];
                if ($this.Variables == null) $this.Variables = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Variables.length > 0) {
                    Domain.EmployeePayroll.removeVariables($this, $this.Variables[0]);
                }

                Domain.EmployeePayroll.addManyVariables($this, copyItems);
            }
static addManyVariables = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayroll.addVariables($this, items[i]);
                }
            }
static addVariables = ($this, item) => {
                if ($this.Variables == null) $this.Variables = [];
                if (item == null || $this.Variables.indexOf(item) > -1) return;
                $this.Variables.push(item);
if (item.Payroll != $this) {
Domain.PayrollVariableInstance.setPayroll(item, $this);
}
}
static addRangeVariables = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayroll.addVariables($this, item));
            }
static removeVariables = ($this, item) => {
                if ($this == null || $this.Variables == null || $this.Variables.indexOf(item) === -1) return;
                var _index = $this.Variables.indexOf(item);
                $this.Variables.splice(_index, 1);
item.Payroll = null;
}
static clearVariables = ($this) => { $this.Variables = null; }
static setAdhocAdvancePayments = ($this, items) => {
                if (items == null) items = [];
                if ($this.AdhocAdvancePayments == null) $this.AdhocAdvancePayments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AdhocAdvancePayments.length > 0) {
                    Domain.EmployeePayroll.removeAdhocAdvancePayments($this, $this.AdhocAdvancePayments[0]);
                }

                Domain.EmployeePayroll.addManyAdhocAdvancePayments($this, copyItems);
            }
static addManyAdhocAdvancePayments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayroll.addAdhocAdvancePayments($this, items[i]);
                }
            }
static addAdhocAdvancePayments = ($this, item) => {
                if ($this.AdhocAdvancePayments == null) $this.AdhocAdvancePayments = [];
                if (item == null || $this.AdhocAdvancePayments.indexOf(item) > -1) return;
                $this.AdhocAdvancePayments.push(item);
if (item.ClearedOn != $this) {
Domain.AdhocAdvancePayment.setClearedOn(item, $this);
}
}
static addRangeAdhocAdvancePayments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayroll.addAdhocAdvancePayments($this, item));
            }
static removeAdhocAdvancePayments = ($this, item) => {
                if ($this == null || $this.AdhocAdvancePayments == null || $this.AdhocAdvancePayments.indexOf(item) === -1) return;
                var _index = $this.AdhocAdvancePayments.indexOf(item);
                $this.AdhocAdvancePayments.splice(_index, 1);
item.ClearedOn = null;
}
static clearAdhocAdvancePayments = ($this) => { $this.AdhocAdvancePayments = null; }

static CalcPercentageSalary($this: any): any{let percentage = 1.0;
try {let FictitiousDays = ($this?.Contract?.Template?.ContractType?.ForPublicSector ? 30 : 25);let DaysMonth = moment("moment(moment().toDate()).year()-(moment(moment().toDate()).month()+1)", "YYYY-MM").daysInMonth();let AdditionalDays = ($this?.Contract?.Template?.ContractType?.ForPublicSector ? Joove.Common.safeNumber(FictitiousDays) - Joove.Common.safeNumber(DaysMonth) : 0);let EndDateMonth = moment([moment(moment().toDate()).year(), ((moment(moment().toDate()).month() + 1)) - 1, DaysMonth]).toDate();}
catch (e) {console.warn(e?.message);}
return percentage;
}
static CalculatePaidDaysPublicSector($this: any, workedDays: any): any{let finalPaidDays = null;
let monthDays = moment("$this?.PayrollCalculation?.Period?.Year-(moment($this?.PayrollCalculation?.Period?.From).month()+1)", "YYYY-MM").daysInMonth();
let calibrateDays = 30;
let additionalDays = Joove.Common.safeNumber(calibrateDays) - Joove.Common.safeNumber(monthDays);
let paidDays = calibrateDays;
let notWorkedDays = Joove.Common.safeNumber(monthDays) - Joove.Common.safeNumber(workedDays);
paidDays = workedDays;
if (CLMS.Framework.Number.GreaterThanOrEqual(() => workedDays, () => notWorkedDays)) {paidDays = Joove.Common.safeNumber(paidDays) + Joove.Common.safeNumber(additionalDays);}else {paidDays = Joove.Common.safeNumber(paidDays) - Joove.Common.safeNumber(additionalDays);}
try {$this.DaysWorked = parseFloat((paidDays) as any);}
catch (x) {console.warn(x?.message);}
}
static CalculatePeriodWeight($this: any): any{let weightRule = $this?.Contract?.SalaryPeriods?.linq?.where((p) => p?.SalaryPeriod?.SystemType == $this?.PayrollCalculation?.Period?.Type?.SystemType)?.firstOrDefault(null);
return (weightRule != null ? weightRule?.Weight : $this?.PayrollCalculation?.Period?.Weight);
}
static CalculateSeperateSalaries(emp: any): any{let BasicSalariesList = [];
BasicSalariesList = emp?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Basic)?.toArray();
let OtherSalariesList = [];
OtherSalariesList = emp?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Other)?.toArray();
let dailySalary = null;
let Amount = null;
let SalaryById = new window['Map']();
for (let _ibs = 0; _ibs < (BasicSalariesList == null ? 0 : BasicSalariesList.length); _ibs++) {let bs = BasicSalariesList[_ibs];dailySalary = (CLMS.Framework.Number.LessThanOrEqual(() => emp.Contract.Template.ContractType.PeriodDays, () => 0) ? 0.0 : Joove.Common.safeNumber(bs?.Amount) / Joove.Common.safeNumber(emp?.Contract?.Template?.ContractType?.PeriodDays));Amount = (CLMS.Framework.Number.Equal(() => emp.DaysWorked, () => 0) ? Joove.Common.safeNumber(dailySalary) * Joove.Common.safeNumber(25) : Joove.Common.safeNumber(dailySalary) * Joove.Common.safeNumber(emp?.DaysWorked));SalaryById.set(bs?.Salary?.Id, Amount);}
for (let _ios = 0; _ios < (OtherSalariesList == null ? 0 : OtherSalariesList.length); _ios++) {let os = OtherSalariesList[_ios];SalaryById.set(os?.Salary?.Id, os?.Amount);}
return SalaryById;
}
static CalculateWorkedDaysPublicSector($this: any): any{let monthDays = moment("$this?.PayrollCalculation?.Period?.Year-(moment($this?.PayrollCalculation?.Period?.From).month()+1)", "YYYY-MM").daysInMonth();
let endDate = new Date();
let startDate = new Date();
if (Domain.DateHelper.IsDateNull($this?.Contract?.EndDate)) {endDate = $this?.PayrollCalculation?.Period?.To;}else {endDate = (CLMS.Framework.Number.Equal(() => CLMS.Framework.DateTime.Compare($this.Contract.EndDate, $this.PayrollCalculation.Period.To), () => -1) ? $this?.Contract?.EndDate : $this?.PayrollCalculation?.Period?.To);}
startDate = (CLMS.Framework.Number.Equal(() => CLMS.Framework.DateTime.Compare($this.Contract.StartDate, $this.PayrollCalculation.Period.From), () => -1) ? $this?.PayrollCalculation?.Period?.From : $this?.Contract?.StartDate);
let diff = Joove.Common.dateDiff(endDate, startDate);
let workedDays = Joove.Common.safeNumber(diff?.days) + Joove.Common.safeNumber(1);
if (CLMS.Framework.Number.LessThan(() => workedDays, () => monthDays)) {Domain.EmployeePayroll.CalculatePaidDaysPublicSector($this, workedDays);return true;}
$this.DaysWorked = $this?.Contract?.Template?.ContractType?.BaseCalculationDays;
return true;
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static GetDaysInRange(contract: any,from: any,to: any): any{from = ((new Date(contract?.StartDate).getTime()) > (new Date(from).getTime()) ? contract?.StartDate : from);
if ((new Date(from).getTime()) >= (new Date(to).getTime())) {return 0;}
return Joove.Common.dateDiff(to, from)?.days;
}
static GetDaysPerPeriod(payroll: any,imerologiakes: any): any{if ((new Date(new Date(new Date(payroll?.Contract?.StartDate)?.setHours(0, 0, 0, 0))).getTime()) >= (new Date(new Date(new Date(payroll?.PayrollCalculation?.Period?.To)?.setHours(0, 0, 0, 0))).getTime())) {return 0;}
if (imerologiakes) {return Domain.EmployeePayroll.GetDaysInRange(payroll?.Contract, payroll?.PayrollCalculation?.Period?.From, payroll?.PayrollCalculation?.Period?.To);}else {return payroll?.DaysWorked;}
}
static GetVariableValue($this: any, vCode: any): any{let instance = $this?.Variables?.linq?.where((v) => v?.Variable?.Code == vCode)?.firstOrDefault(null);
if (instance == null) {return null;}
return instance?.Value;
}
static SetVariableInstanceValue($this: any, instance: any,value: any): any{if (instance?.UpdatedByUser == true) {console.debug("Variable " + instance?.Variable?.Name + " has value set by user so canno overide");return;}
instance.Value = value;
}
static SplitTaxes(taxDetail: any,salaries: any,contributions: any,totalTaxAmount: any,totalTaxableAmount: any): any{for (let _isalary = 0; _isalary < (salaries == null ? 0 : salaries.length); _isalary++) {let salary = salaries[_isalary];let item = taxDetail?.Items?.linq?.where((ti) => ti?.Salary == salary)?.firstOrDefault(null);if (item == null) {item = new Domain.PayrollTaxDetailItem();Domain.PayrollTaxDetailItem.setSalary(item, salary);taxDetail?.Items?.add(item);}let contribution = contributions?.linq?.where((c) => c?.Salaries?.linq?.contains(salary))?.toArray()?.linq?.sum((s) => s?.EmployeeContribution);item.TaxableAmount = Joove.Common.safeNumber(salary?.Amount) - Joove.Common.safeNumber(contribution);if (CLMS.Framework.Number.Equal(() => salaries.length, () => 1)) {item.Tax = totalTaxAmount;}else if (salary == salaries?.linq?.lastOrDefault()) {item.Tax = Joove.Common.safeNumber(totalTaxAmount) - Joove.Common.safeNumber(taxDetail?.Items?.linq?.sum((t) => t?.Tax));}else {item.Tax = Joove.Common.safeNumber((Joove.Common.safeNumber(item?.TaxableAmount) / Joove.Common.safeNumber(totalTaxableAmount))) * Joove.Common.safeNumber(totalTaxAmount);}}
}
static UpdateTotalAmounts($this: any): any{$this.MainSalary = $this?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Main)?.toArray()?.linq?.sum((s) => s?.Amount);
$this.OtherSalary = $this?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Other)?.toArray()?.linq?.sum((s) => s?.Amount);
$this.TotalSalary = Joove.Common.safeNumber($this?.MainSalary) + Joove.Common.safeNumber($this?.OtherSalary);
$this.BonusAmount = $this?.Salaries?.linq?.where((s) => s?.BonusIncrease)?.toArray()?.linq?.sum((s) => s?.Amount);
$this.EmployeeContributions = $this?.Contributions?.linq?.sum((s) => s?.EmployeeContribution);
$this.EmployerContributions = $this?.Contributions?.linq?.sum((s) => s?.EmployerContribution);
$this.Tax = $this?.Taxes?.linq?.sum((t) => t?.Tax);
if ($this?.PayrollCalculation?.CancelNegativeTax && CLMS.Framework.Number.LessThan(() => $this.Tax, () => 0)) {$this.Tax = 0;}
$this.RegularTax = $this?.Taxes?.linq?.sum((t) => t?.RegularTax);
$this.EmployeeDeductions = $this?.Deductions?.linq?.sum((s) => s?.EmployeeAmount);
$this.EmployerDeductions = $this?.Deductions?.linq?.sum((s) => s?.EmployerAmount);
$this.PayableAmount = Joove.Common.safeNumber($this?.TotalSalary) - Joove.Common.safeNumber($this?.EmployeeContributions) - Joove.Common.safeNumber($this?.EmployeeDeductions) - Joove.Common.safeNumber($this?.Tax) - Joove.Common.safeNumber($this?.EmployerDeductions) - Joove.Common.safeNumber($this?.AdvanceAmount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}